import React, { useContext, useEffect } from 'react'
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ModalWindow from '../../layout/modalwindow/ModalWindow';
import DropDownWindow from '../../layout/DropDownWindow';
import RegisterProductController from '../registerproduct/RegisterProductController'
import { ContentInner } from '../../layout/Content'
import { productsListControllerContext } from './ProductsListController'
import { formatNumber } from '../../utilities/utilities'
import { appContext } from '../../../App'
import ProductsListInnerStyle from './css/ProductsListInnerStyle'

function ProductsListInner() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const productsListController = useContext(productsListControllerContext)
  const { recordFound, deleteProduct, setAllCheck, reloadProductsList } = productsListController
  const { clearItemToDeleteList, addItemToDeleteList, removeItemsToDeleteList } = productsListController
  const products = productsListController.products
  const [recordPerPage] = productsListController.recordPerPage
  const [page] = productsListController.page
  const [startSlice, setStartSlice] = productsListController.startSlice
  const [endSlice, setEndSlice] = productsListController.endSlice
  const [showDropDownWindow, setShowDropDownWindow] = app.showDropDownWindow

  function ProductsListInnerDropDownWindow({product_id}) {

    const onClickEdit = (e) => {
      setContent(<RegisterProductController product_id={product_id}/>)
      setShowDropDownWindow({show: false, itemId: null})
    }

    const onClickDelete = (e) => {
      const item_name = e.target.closest('.item-name-and-id').querySelector('.item-name').textContent

      const showMessageBoxDeleteProduct = async () => {
        const onClick = async (button) => {
          switch(button) {
            case 'Yes':
              await deleteProduct(app, product_id)
              await clearItemToDeleteList()
              reloadProductsList()
              setAllCheck(false)
            break
            default:
          }
          ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
        }

        ReactDOM.render (
          <ModalWindow
            id='mw-parent'
            width='40'
            height='30'
            header='Delete Product'
            footer={null}>
              <div className='messagebox'>
                <div className='messagebox-content'>
                  <div><span style={{color: 'red'}}>{item_name}</span> will be deleted.</div>
                  <br/>
                  <div>Do you want to continue?</div>
                </div>
                <div className='button-container'>
                  <button onClick={() => onClick('No')} className='pospro-action-btn top-anchor'>No</button>
                  <button onClick={() => onClick('Yes')} className='pospro-action-btn bottom-anchor'>Yes</button>
                </div>
              </div>
          </ModalWindow>,
          document.getElementById('modal-form-container')
        )
      }

      showMessageBoxDeleteProduct()
      setShowDropDownWindow({show: false, itemId: null})
    }

    return (
      <DropDownWindow>
        <button className='pospro-action-btn' onClick={onClickEdit}>Edit</button>
        <button className='pospro-action-btn' onClick={onClickDelete}>Delete</button>
      </DropDownWindow>
    )
  }

  const noRecordFoundNotification = () => {
    let displayAddNew = 'block'
    if (app.client.signed_in !== 'admin')
      displayAddNew = (app.client.signed_in.user_access.products_add_new) ? 'block' : 'none'
    return (
      <React.Fragment>
        <div className="notification">
          <div className="no-record-found-alert">No records found!</div>
          <br />
          <div style={{display: displayAddNew}}>Consider adding new product
            <span>
              {' '}
              <button
                className="pospro-action-btn"
                onClick={() => setContent(<RegisterProductController mode={'add'}/>)}>
                <FontAwesomeIcon icon='plus'/>{' '}Add
              </button>
            </span>
          </div>
          </div>
      </React.Fragment>
    )
  }

  const onChangeCheck = (e) => {
    const itemId = e.target.closest('.data-row').dataset['key']
    e.target.checked ? addItemToDeleteList(itemId) : removeItemsToDeleteList(itemId)
  }

  const getAccumulatedUnitQuantity = (product, currentUnit) => {
    let totalAccumulatedUnitQuantity = 0

    const unitsCurrentUnitExcluded = product.units
    .filter(unit => unit.description !== currentUnit.description)

    // Is there siblings units
    if (unitsCurrentUnitExcluded.length > 0) {

      // Loop in each unit
      unitsCurrentUnitExcluded
      .forEach((unit, i) => {

        let accumulatedUnitQuantity = 1

        if (unit.description.search(currentUnit.unit_name) > 0) {
          // A child of a container
          const unitDescriptionSplitted = unit.description.split('(').filter(item => parseFloat(item))

          if (unitDescriptionSplitted.length > 0) {
            let i = 0
            let found = false

            while (!found && (i < unitDescriptionSplitted.length)) {
              accumulatedUnitQuantity *= parseFloat(unitDescriptionSplitted[i])
              found = (unitDescriptionSplitted[i++].search(currentUnit.unit_name) > 0)
            }
            accumulatedUnitQuantity *= parseFloat(unit.inventory)
          }
        } else if (currentUnit.description.search(unit.unit_name) > 0) {
          // A container
          const unitDescriptionSplitted = currentUnit.description.split('(').filter(item => parseFloat(item))

          if (unitDescriptionSplitted.length > 0) {
            let i = 0
            let found = false

            while (!found && (i < unitDescriptionSplitted.length)) {
              accumulatedUnitQuantity *= parseFloat(unitDescriptionSplitted[i])
              found = (unitDescriptionSplitted[i++].search(unit.unit_name) > 0)
            }
            accumulatedUnitQuantity = parseInt(unit.inventory / accumulatedUnitQuantity)
          }
        } else {
          // If units have same contents
          // Ex: Promo1(5xKilo), Promo2(2.5xKilo)
          if (unit.contents === currentUnit.contents) {
            accumulatedUnitQuantity = parseInt((unit.contents_quantity * unit.inventory) / currentUnit.contents_quantity)
          }
        }

        // Sum per unit loop
        totalAccumulatedUnitQuantity +=  accumulatedUnitQuantity

      } )

      // Add the current unit inventory at the end
      totalAccumulatedUnitQuantity +=  currentUnit.inventory

    } else {
      // There is no other unit than the current
      totalAccumulatedUnitQuantity = currentUnit.inventory
    }

    return (totalAccumulatedUnitQuantity)
  }

  const onClickItemOptionDrop = (e) => {
    const itemId = e.target.closest('.data-row').dataset['key']
    if (showDropDownWindow)
      setShowDropDownWindow({ show: (!showDropDownWindow.show), itemId })
    else setShowDropDownWindow({ show: true, itemId })
  }

  useEffect(() => {
    setStartSlice((page - 1) * recordPerPage)
    setEndSlice(page * recordPerPage)
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, recordPerPage])

  useEffect(() => {
    // Close visible drop down window
    const ddwindows = document.querySelectorAll('.dd-window-container')
    if (ddwindows) {
      ddwindows.forEach((item, i) => {
        ReactDOM.unmountComponentAtNode(document.getElementById(item.id))
      })
    }

    if (showDropDownWindow) {
      if (showDropDownWindow.show) {
        ReactDOM.render(
          <ProductsListInnerDropDownWindow product_id={showDropDownWindow.itemId} />,
          document.getElementById(showDropDownWindow.itemId)
        )
      } else {
        if (showDropDownWindow.itemId) ReactDOM.unmountComponentAtNode(document.getElementById(showDropDownWindow.itemId))
      }
    }
  }, [showDropDownWindow])

  return (
    <ContentInner>
      <div id="data-row-container" >
        {
          recordFound ?
          products.slice(startSlice, endSlice).map((product) =>
            <div className="data-row" data-key={product._id} key={product._id}>
              <div className="item-name-and-id">
                <div className="item-name">
                  <span style={{color: "white"}}>{product.brand}</span> {product.name} {product.description}
                </div>
                <div className="item-buttons">
                  <input className='item-checkbox' onChange={onChangeCheck} type="checkbox" />
                  <button
                    onClick={onClickItemOptionDrop}
                    className="pospro-action-btn item-option-drop">
                    <FontAwesomeIcon icon='caret-down'/>
                  </button>
                  <div id={product._id} className='dd-window-container'>
                  </div>
                </div>
              </div>
              <table className="table-unit-details striped-table">
                <thead>
                  <tr>
                    <th>Unit Name</th>
                    <th>Unit Description</th>
                    <th style={{textAlign: 'center'}}>Vatable</th>
                    <th style={{textAlign: 'right'}}>Capital Amount</th>
                    <th style={{textAlign: 'right'}}>Wholesale Price</th>
                    <th style={{textAlign: 'right'}}>Retail Price</th>
                    <th style={{textAlign: 'center'}}>Inventory</th>
                    <th style={{textAlign: 'center'}}>Accumulated Inventory</th>
                  </tr>
                </thead>
                {
                  product.units.map((unit) =>
                    <tbody key={unit.id}>
                      <tr>
                        <td>{unit.unit_name}</td>
                        <td>{unit.description}</td>
                        <td style={{textAlign: 'center'}}>{(unit.vatable) ? 'Yes' : 'No'}</td>
                        <td style={{textAlign: 'right'}}>{formatNumber(unit.capital_amount.toFixed(2))}</td>
                        <td style={{textAlign: 'right'}}>{formatNumber(unit.wholesale_price.toFixed(2))}</td>
                        <td style={{textAlign: 'right'}}>{formatNumber(unit.retail_price.toFixed(2))}</td>
                        <td style={{textAlign: 'center'}}>{formatNumber(unit.inventory.toFixed(2))}</td>
                        <td style={{textAlign: 'center'}}>
                        {
                          // Find the current unit in units collection of the current item
                          formatNumber(getAccumulatedUnitQuantity(product, unit))
                        }
                        </td>
                      </tr>
                    </tbody>
                  )
              }
            </table>
            </div>
          )
          : noRecordFoundNotification()
        }
      </div>
      <ProductsListInnerStyle signed_in={app.client.signed_in}/>
    </ContentInner>
  )
}

export default React.memo(ProductsListInner)